export var ServiceWorkerEvents;
(function (ServiceWorkerEvents) {
    ServiceWorkerEvents["SaveICHostInfo"] = "SaveICHostInfo";
    ServiceWorkerEvents["ResetServiceWorker"] = "ResetServiceWorker";
})(ServiceWorkerEvents || (ServiceWorkerEvents = {}));
